import { REGULAR_TRANSLATIONS } from '~shared/constants/translations.constant';

export const EDIT_ADDRESS_ACTION_LIST = [
  {
    type: 'submit',
    text: REGULAR_TRANSLATIONS.save,
  },
  {
    type: 'remove',
    text: 'PAGES.ACCOUNT.ADDRESS_BOOK.REMOVE_ADDRESS',
    extras: {
      color: 'ghost-warning',
    },
  },
];
